import React from 'react'
import LinearProgress from '@mui/material/LinearProgress';

export const ProgressBar = (props) => {
    /*console.log(props)*/
   
    return (
        <div style={{ height: '5px' }}>
            {props.isVisible &&
                <LinearProgress className="progress-bar" />
            }
        </div>
    )
}
